import React, { useMemo } from 'react';
import InformationInterestView from './components/InformationInterestView';
import TemplateScreen from 'screens/TemplateScreen';
import { useLocation } from 'react-router-dom';

const InformationInterest = () => {
  const location = useLocation();
  const origin = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('origin');
  }, [location.search]);
  return (
    <TemplateScreen
      Screen={(eventData) => (
        <InformationInterestView eventData={eventData} origin={origin} />
      )}
    />
  );
};

export default InformationInterest;
